// extracted by mini-css-extract-plugin
export default {"container":"_2UkVYwLx","header":"_2-08pSap","column":"_2NdrgXap","middle":"_1Gt0Sqdt","tick":"_1F4buAit","dot":"QFP9iKDZ","footerTermsText":"_22MvBZ1Z"};